import { batch, connect } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  actions as deliveryZoneOptionsActions,
  SelectCountryPayload,
  selectDeliveryZoneOptionsIsLoading,
  selectSelectedCountry,
  selectSelectedZone,
} from 'src/redux/deliveryZoneOptions';
import { selectHasSelectedCountriesDeliveryOnly, selectHasUKDeliveryOnly } from 'src/redux/product';
import { DeliveryBlock } from '../components/DeliveryBlock';
import {
  selectCountriesForDropdown,
  selectDecoratedDeliveryOptions,
  selectProductDeliveryOptionsForZone,
} from '../modules';

const mapStateToProps = (state: ReduxApplicationState) => ({
  countries: selectCountriesForDropdown(state),
  deliveryOptions: selectDecoratedDeliveryOptions(state),
  deliveryOptionsPlaceholderItems: selectProductDeliveryOptionsForZone(state),
  selectedCountry: `${selectSelectedCountry(state)}|${selectSelectedZone(state)}`,
  hasUkDeliveryOnly: selectHasUKDeliveryOnly(state),
  hasSelectedCountriesDeliveryOnly: selectHasSelectedCountriesDeliveryOnly(state),
  isLoading: selectDeliveryZoneOptionsIsLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onCountryChange: (payload: SelectCountryPayload) =>
    batch(() => {
      dispatch(deliveryZoneOptionsActions.setSelectedCountry(payload));
      dispatch(deliveryZoneOptionsActions.setSelectedZone(payload.selectedZone));
    }),
});

export const DeliveryBlockContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveryBlock);
